(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NavbarController', NavbarController)
        .constant('LOGO_REDIRECT_URLS', {
            loginHash:'/v2/auth/login',
            prodRedirectUrl:'https://www.valueconnect.ca',
            nonProdRedirectUrl:'https://yahoo.ca',
            dashboardHash:'/v2/dashboard/'
        });

    NavbarController.$inject = ['$rootScope', '$scope', '$state', '$window', 'Auth', 'Principal', 'ProfileService', 'LoginService','LOGO_REDIRECT_URLS'];

    function NavbarController ($rootScope, $scope, $state, $window,  Auth, Principal, ProfileService, LoginService, LOGO_REDIRECT_URLS) {
        var vm = this;
        console.log($window);

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        var v2DashboardBaseUrl = '';
        var v2OrderBaseUrl = '';

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerDisabled = response.swaggerDisabled;
            v2DashboardBaseUrl = response.v2DashboardBaseUrl || '';
            v2OrderBaseUrl = response.v2OrderBaseUrl || '';
        });

        vm.login = login;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.redirect = redirect;
        vm.navigateToPlaceOrder = navigateToPlaceOrder;
        vm.$state = $state;

        setIdentity();
        setBrokerage();
        setAppraisalFirm();
        $rootScope.$on('authenticationSuccess', function() {
            setIdentity();
            setBrokerage();
            setAppraisalFirm();
        });

        function setIdentity() {
            Principal.identity().then(function(_id) {
                vm.identity = _id;
            });
        }

        function setBrokerage() {
            Principal.getBrokerageId().then(function(brokerageId) {
                vm.brokerageId = brokerageId;
            });
        }

        function setAppraisalFirm() {
            Principal.getAppraisalFirmId().then(function(appraisalFirmId) {
                vm.appraisalFirmId = appraisalFirmId;
            });
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function redirect(){
            if(vm.inProduction && $window.location.pathname === LOGO_REDIRECT_URLS.loginHash){
                $window.location.href = LOGO_REDIRECT_URLS.prodRedirectUrl;
            }
            else if($window.location.pathname === LOGO_REDIRECT_URLS.loginHash){
                $window.location.href = LOGO_REDIRECT_URLS.nonProdRedirectUrl;
            }else{
                $window.location.href = v2DashboardBaseUrl + LOGO_REDIRECT_URLS.dashboardHash;
            }
        }

        function navigateToPlaceOrder() {
            var baseUrl = v2OrderBaseUrl || ($window.location.protocol + "//" + $window.location.host);
            $window.location.href = baseUrl + "/v2/appraisal-order/new";
        }
    }
})();
